import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { LoaderService } from "src/app/loader/loader.service";
import { environment } from "src/environments/environment";
import { Beneficiary } from "../../sales/models/beneficiary";
import { ProductItem } from "../../sales/models/product-item";
import { Sale } from "../../sales/models/sale";
import { LeadsService } from "../leads.service";

@Component({
  selector: "app-leads-details",
  templateUrl: "./leads-details.component.html",
  styleUrls: ["./leads-details.component.scss"],
})
export class LeadsDetailsComponent implements OnInit {
  env;
  lead: Sale;

  beneficiariesPage = 1;
  beneficiariesPageSize = 10;
  beneficiariesCollectionSize = 0;
  beneficiaries$: Observable<Beneficiary[]>;
  beneficiariesFilter = new FormControl("");

  itemsPage = 1;
  itemsPageSize = 10;
  itemsCollectionSize = 0;
  items$: Observable<ProductItem[]>;
  itemsFilter = new FormControl("");

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public leadsService: LeadsService,
    private loaderService: LoaderService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.getLead(this.env.selected.cnpj, this.route.snapshot.paramMap.get("id"));
  }

  async getLead(cnpj: string, id: string) {
    const loader = await this.loaderService.notifica({
      title: "Buscando lead...",
      date: moment().toISOString(),
      type: "loading",
    });

    this.lead = await this.leadsService.getLead(cnpj, id).toPromise();

    this.beneficiaries$ = this.beneficiariesFilter.valueChanges.pipe(
      startWith(""),
      map(text => this.beneficiariesSearch(text, this.lead.beneficiarios))
    );

    this.items$ = this.itemsFilter.valueChanges.pipe(
      startWith(""),
      map(text => this.itemsSearch(text, this.lead.produtos))
    );

    loader.dismiss();
  }

  beneficiariesSearch(text: string, beneficiaries: Beneficiary[]): Beneficiary[] {
    const datePipe = new DatePipe("pt");

    const beneficiariesFiltered: Beneficiary[] = beneficiaries
      ? beneficiaries.filter(beneficiary => {
          const term = text.toLowerCase();
          return (
            datePipe.transform(beneficiary.nascimento, "dd/MM/yyyy").includes(term) ||
            beneficiary.nome.toLowerCase().includes(term) ||
            beneficiary.cpf.toLowerCase().includes(term) ||
            beneficiary.seguro_nome.toLowerCase().includes(term) ||
            this.getGenre(beneficiary.sexo).toLowerCase().includes(term) ||
            this.getRelatives(beneficiary.parentesco).toLowerCase().includes(term) ||
            this.getCivilState(beneficiary.estado_civil).toLowerCase().includes(term)
          );
        })
      : [];

    this.beneficiariesPage = 1;
    this.beneficiariesCollectionSize = beneficiariesFiltered.length;

    return beneficiariesFiltered;
  }

  itemsSearch(text: string, items: ProductItem[]): ProductItem[] {
    const itemsFiltered: ProductItem[] = items
      ? items.filter(item => {
          const term = text.toLowerCase();
          return (
            item.codigo.toLowerCase().includes(term) ||
            item.descricao.toLowerCase().includes(term) ||
            item.preco.toString().toLowerCase().includes(term) ||
            item.quantidade.toString().toLowerCase().includes(term)
          );
        })
      : [];

    this.itemsPage = 1;
    this.itemsCollectionSize = itemsFiltered.length;

    return itemsFiltered;
  }

  getGenre(genre: string) {
    switch (genre) {
      case "M":
        return "Masculino";
        break;
      case "F":
        return "Feminino";
        break;

      default:
        return "";
        break;
    }
  }

  getCivilState(state: string) {
    switch (state) {
      case "S":
        return "Solteiro";
        break;
      case "C":
        return "Casado";
        break;
      case "D":
        return "Divorciado";
        break;
      case "V":
        return "Viúvo";
        break;
      case "O":
        return "Outros";
        break;
      case "J":
        return "Junto";
        break;
      case "U":
        return "União Estável";
        break;

      default:
        return "";
        break;
    }
  }

  getSchooling(type: string) {
    switch (type) {
      case "1":
        return "Não Escolarizado";
        break;
      case "2":
        return "Ensino Fundamental Incompleto";
        break;
      case "3":
        return "Ensino Fundamental Completo";
        break;
      case "4":
        return "Ensino Médio Incompleto";
        break;
      case "5":
        return "Ensino Médio Completo";
        break;
      case "6":
        return "Superior Incompleto";
        break;
      case "7":
        return "Superior Completo";
        break;
      case "8":
        return "Pós-graduação";
        break;
      case "9":
        return "Mestrado";
        break;
      case "10":
        return "Doutorado";
        break;
      case "11":
        return "Pós-Doutorado";
        break;

      default:
        return "";
        break;
    }
  }

  getRelatives(type: string) {
    switch (type) {
      case "CO":
        return "Cônjuge";
      case "FI":
        return "Filho(a)";
      case "IR":
        return "Irmão(a)";
      case "NE":
        return "Neto(a)";
      case "PA":
        return "Pai";
      case "MA":
        return "Mãe";
      case "OU":
        return "Outros";
      case "SO":
        return "Sogro(a)";
      case "SC":
        return "Segundo cônjuge";
      case "TU":
        return "Tutelado(a)";
      case "CU":
        return "Curatela";
      case "EN":
        return "Entiado(a)";
      case "AG":
        return "Agregado(a)";

      default:
        return "";
    }
  }

  getSaleType(type: string) {
    switch (type) {
      case "1":
        return "Venda";
        break;
      case "2":
        return "Portabilidade";
        break;
      case "3":
        return "Reativação";
        break;

      default:
        return "";
        break;
    }
  }

  getDependentType(type: string) {
    switch (type) {
      case "1":
        return "Beneficiário";
        break;
      case "2":
        return "Agregado";
        break;
      case "3":
        return "Títular";
        break;

      default:
        return "";
        break;
    }
  }

  goLeads(): void {
    this.router.navigateByUrl(`/leads/${this.env.selected.cnpj}`);
  }

  goBack(): void {
    this.router.navigateByUrl(`/salesmodule/${this.env.selected.cnpj}`);
  }
}
